export default {
  settings: {
    external_id: '49',
    id: 'ekspress',
    lang: 'et',
    locale: 'et_EE',
    name: 'Eesti Ekspress',
  },
} as Record<string, any>;
